module.exports = __webpack_public_path__ + "img/result-info-bg.324dc2d4.png";